'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _desc, _value, _class;

var _reduxComponents = require('redux-components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var MapMetadata = (_dec = (0, _reduxComponents.selector)({ isObservable: true }), _dec2 = (0, _reduxComponents.action)({ isDispatcher: true }), _dec3 = (0, _reduxComponents.action)({ isDispatcher: true }), _dec4 = (0, _reduxComponents.action)({ isDispatcher: true }), (_class = function (_ReduxComponent) {
  (0, _inherits3.default)(MapMetadata, _ReduxComponent);

  function MapMetadata() {
    (0, _classCallCheck3.default)(this, MapMetadata);
    return (0, _possibleConstructorReturn3.default)(this, (MapMetadata.__proto__ || (0, _getPrototypeOf2.default)(MapMetadata)).apply(this, arguments));
  }

  (0, _createClass3.default)(MapMetadata, [{
    key: 'reducer',
    value: function reducer() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var action = arguments[1];

      var tmp, k;
      switch (action.type) {
        case this.MAP_ADD:
          tmp = {};tmp[action.payload.key] = action.payload.descriptor;
          return (0, _assign2.default)({}, state, tmp);

        case this.MAP_REMOVE:
          tmp = (0, _assign2.default)({}, state);
          delete tmp[action.payload];
          return tmp;

        case this.MAP_BULK:
          tmp = (0, _assign2.default)({}, state);
          if (action.payload.remove) {
            for (k in action.payload.remove) {
              delete tmp[k];
            }
          }
          if (action.payload.add) {
            for (k in action.payload.add) {
              tmp[k] = action.payload.add[k];
            }
          }
          return tmp;

        default:
          return state;
      }
    }
  }, {
    key: 'getMetadata',
    value: function getMetadata(state) {
      return state;
    }
  }, {
    key: 'add',
    value: function add(key, descriptor) {
      return { type: this.MAP_ADD, payload: { key: key, descriptor: descriptor } };
    }
  }, {
    key: 'remove',
    value: function remove(key) {
      return { type: this.MAP_REMOVE, payload: key };
    }
  }, {
    key: 'bulk',
    value: function bulk(add, remove) {
      return { type: this.MAP_BULK, payload: { add: add, remove: remove } };
    }
  }]);
  return MapMetadata;
}(_reduxComponents.ReduxComponent), (_applyDecoratedDescriptor(_class.prototype, 'getMetadata', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getMetadata'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'add', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'add'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'remove', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'remove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'bulk', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'bulk'), _class.prototype)), _class));
MapMetadata.verbs = ['MAP_ADD', 'MAP_REMOVE', 'MAP_BULK'];
exports.default = MapMetadata;